import * as jwt from 'jsonwebtoken'
import { DecodedJWTStatus } from './types'

/**
 * @function decodeJWT
 * This function allows you decode the JWT Token and read the properties that are into the code.
 * @param token
 * @returns decoded and isValid properties
 */
export const decodeJWT = (token: string | undefined): DecodedJWTStatus => {
  let decoded: DecodedJWTStatus['decoded'] = ''
  try {
    decoded = token && jwt.decode(token)
  } catch (err) {
    return {
      isValid: false,
      decoded: undefined,
    }
  }
  return {
    isValid: true,
    decoded,
  }
}
